const defaultMessages =
	document.documentElement.lang === "en-US"
		? {
				required: "This field is required.",
				minLength: (value) => `Please enter at least ${value} characters.`,
				maxLength: (value) => `You must enter ${value} characters.`,
				over: (value) => `You must be over ${value} years old.`,
				under: `Please enter a valid date.`,
		  }
		: {
				required: "Este campo es obligatorio.",
				minLength: (value) => `Por favor, no escribas menos de ${value} caracteres.`,
				maxLength: (value) => `Por favor, no escribas más de ${value} caracteres.`,
				over: (value) => `Debes ser mayor de ${value} años.`,
				under: `Por favor, escribe una fecha valida.`,
		  };

const getErrorMessage = async (value, rules, messages) => {
	const { required, minLength, maxLength, regex, over, under, remoteValidate } = rules;
	if (required && value === "") return messages.required || defaultMessages.required;
	if (minLength && value.length < minLength) return messages.minLength || defaultMessages.minLength(minLength);
	if (maxLength && value.length > maxLength) return messages.maxLength || defaultMessages.maxLength(maxLength);
	if (regex && !regex.test(value)) return messages.regex;

	if (over || under) {
		let currentYear = new Date().getFullYear();
		var age = currentYear - value.substr(value.length - 4);
	}

	if (over && age < over) return messages.over || defaultMessages.over(over);
	if (under && age >= under) return messages.under || defaultMessages.under;

	if (remoteValidate) {
		const valueRemoteValidate = await fetch(remoteValidate.url.replaceAll("{value}", value));
		const valueRemoteValidateJson = await valueRemoteValidate.json();

		return remoteValidate.processData(valueRemoteValidateJson) ? messages.remoteValidate : null;
	}
};

const clearLabelError = (element) => {
	const childs = element.childNodes;

	const labelChilds = Array.from(childs).filter((child) => child.nodeName === "LABEL");

	const lastLabel = labelChilds.at(-1);

	if (lastLabel && lastLabel.className === "js-form-error") lastLabel.remove();
};

const validating = (validateConfig) => {
	const inputElements = validateConfig.map((validateConfigItem) => ({ element: document.querySelector(`#${validateConfigItem.elementID}`), validateConfigItem })).filter((input) => input.element);

	const validateAll = () =>
		inputElements.forEach((inputElement) => {
			const { element, validateConfigItem } = inputElement;

			const validate = () => {
				validateInput(element, validateConfigItem);
				setEventListeners(element, validateConfigItem); //Para cuando se hace blur por primera vez
				element.removeEventListener("blur", validate);
			};
			element.addEventListener("blur", validate);
		});
	validateAll();

	const validateForm = () =>
		inputElements.map(async (inputElement) => {
			const { element, validateConfigItem } = inputElement;

			setEventListeners(element, validateConfigItem); //Para que se agregen los escuchadores cuando se hace enviar formulario de esa manera se evita tener que esperar al evento blur de los elements
			return { element, value: await validateInput(element, validateConfigItem) };
		});

	return { validateForm };
};

const setEventListeners = (input, validateConfigItem) => {
	["keyup", "change"].forEach((event) =>
		input.addEventListener(event, function (e) {
			validateInput(input, validateConfigItem);
		})
	);
};

const validateInput = async (input, validateConfigItem) => {
	const { rules, messages } = validateConfigItem;
	const value = input.value;

	return getErrorMessage(value, rules, messages).then((res) => {
		let errorMessage = res;
		const parent = input.parentNode.className === "c-hero-form__file-content" ? input.parentNode.parentNode : input.parentNode;
		clearLabelError(parent);

		if (errorMessage) {
			input.classList.add("js-form-error");
			input.classList.remove("js-form-valid");
			const labelErrorElement = document.createElement("label");
			labelErrorElement.classList.add("js-form-error");
			labelErrorElement.setAttribute("for", input.id);
			labelErrorElement.textContent = errorMessage;
			parent.appendChild(labelErrorElement);
			return false;
		} else {
			input.classList.remove("js-form-error");
			input.classList.add("js-form-valid");
			clearLabelError(parent);
			return true;
		}
	});
};
